export var useQueryPostProcessing = function useQueryPostProcessing(_ref) {
  var filters = _ref.filters,
      orderBy = _ref.orderBy,
      steps = _ref.steps,
      propertyNames = _ref.propertyNames;
  return !!(filters || orderBy || steps || propertyNames);
};